import { Grid, TextField, InputAdornment } from '@mui/material';
import { ChangeEvent } from 'react';
import { CreateSnapshotMarkerDelta, ParsedMarker } from './types';

interface Props {
  markers: ParsedMarker[];
  data: number[];
  markerDeltaAlarms: CreateSnapshotMarkerDelta[];
  handleMarkerDeltasChanged: (
    event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
    index: number
  ) => void;
  disabled?: boolean;
}

const MarkerDeltaDisplay = ({
  markers,
  data,
  markerDeltaAlarms,
  handleMarkerDeltasChanged,
  disabled,
}: Props) => {
  const getAmpDelta = (index: number) => {
    if (markers.length < index || !data) return;
    if (markers.length < 0 || !markers[0] || !markers[index]) return;

    const m1AmpValue = data[markers[0].x_pos];
    const m2AmpValue = data[markers[index].x_pos];

    if (isNaN(m2AmpValue - m1AmpValue)) return 'Unable to Calculate';

    return (m2AmpValue - m1AmpValue).toFixed(2);
  };

  const findValueByMarker2Index = (
    index: number,
    name: 'upperbound' | 'lowerbound'
  ) => {
    const markerDelta = markerDeltaAlarms.find(
      (markerDelta) => index === markerDelta?.marker2_index
    );
    if (
      markerDelta !== null &&
      markerDelta !== undefined &&
      markerDelta[name] !== undefined
    ) {
      if (
        Number(markerDelta[name]) === 0 ||
        // @ts-ignore
        isNaN(markerDelta[name] / 1000.0)
      ) {
        return markerDelta[name];
      }
      // @ts-ignore
      return markerDelta[name] / 1000.0;
    } else {
      return '';
    }
  };

  return (
    <>
      {[1, 2, 3].map((item) => (
        <Grid item container key={item} spacing={1}>
          <Grid item xs={3} lg={4} style={{ minWidth: '8rem' }}>
            <TextField
              label={`M${item + 1} - M1`}
              name={'' + item}
              placeholder='Delta'
              value={getAmpDelta(item) || ''}
              variant='outlined'
              size='small'
              disabled
              InputProps={{
                endAdornment: (
                  <InputAdornment position='end'>dB</InputAdornment>
                ),
              }}
              fullWidth
            />
          </Grid>
          <Grid
            item
            container
            xs={6}
            spacing={1}
            style={{ minWidth: '14.5rem' }}
          >
            <Grid item xs={6}>
              <TextField
                label='> Delta'
                name='upperbound'
                placeholder='> Delta'
                value={findValueByMarker2Index(item, 'upperbound')}
                variant='outlined'
                size='small'
                InputProps={{
                  endAdornment: (
                    <InputAdornment position='end'>dB</InputAdornment>
                  ),
                }}
                onChange={(event) => handleMarkerDeltasChanged(event, item)}
                disabled={disabled}
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                label='< Delta'
                name='lowerbound'
                placeholder='< Delta'
                value={findValueByMarker2Index(item, 'lowerbound')}
                variant='outlined'
                size='small'
                InputProps={{
                  endAdornment: (
                    <InputAdornment position='end'>dB</InputAdornment>
                  ),
                }}
                onChange={(event) => handleMarkerDeltasChanged(event, item)}
                disabled={disabled}
              />
            </Grid>
          </Grid>
        </Grid>
      ))}
    </>
  );
};

export default MarkerDeltaDisplay;
